import { css } from 'lit';

export const q1ExternalResourceListStyles = css`
  :host {
    display: block;
  }

  #base-container {
    position: relative;
    overflow: hidden;
    border: 1px solid var(--gray-2);
    border-radius: 7px;
  }

  query-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: var(--gray-0);
    border-bottom: 1px solid var(--gray-2);
  }

  query-bar .spacer {
    flex: 1 1 auto;
  }

  table-wrapper {
    display: block;
    overflow: auto;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: none;

    --table-edge-cell-padding: 1rem;
    --table-cell-padding: 0.5rem;
    --table-border: 1px solid var(--gray-2);
  }

  table td {
    font-size: 0.9rem;
    font-weight: 400;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: var(--table-cell-padding);
    background: var(--gray-0);
  }

  table td:first-child {
    padding-left: var(--table-edge-cell-padding);
  }

  table td:last-child {
    padding-right: var(--table-edge-cell-padding);
  }

  table tr:not(:last-child) td {
    border-bottom: var(--table-border);
  }

  sl-icon {
    font-size: 1.2em;
  }

  .icon-left {
    margin-right: 0.5rem;
    color: var(--gray-6);
    font-size: 1.2rem;
    vertical-align: middle;
  }

  .actions-col {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  tr.empty-placeholder td .td-inner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--gray-6);
    font-size: 1rem;
    line-height: 1.5em;
    font-weight: 300;
    font-style: italic;
    margin: 0.5rem 0;
  }

  button-bar {
    display: flex;
    justify-content: flex-end;
  }

  button-bar sl-button:not(:last-child) {
  margin-right: 0.75rem;
}

  button {
    margin-left: 0.5rem;
  }

  .right-align {
    justify-content: flex-end;
    margin-top: 2rem;
  }

  .external-resource-form {
    padding-top: 0.5rem;
  }

  .external-resource-form .form-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.25rem;
  }

  .external-resource-form .form-row > * {
    flex: 1;
  }

  .external-resource-form .icon-selector {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .external-resource-form .icon-label {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 0.25rem;
  }

  .external-resource-form ::part(base) {
    margin-bottom: 1rem;
  }

  .icon-dropdown-wrapper {
    display: inline-block;
  }

  .icon-dropdown-trigger::part(base) {
    padding: 0.25rem;
    min-width: auto;
    width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .menu-icon {
    margin-right: 0.5rem;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
  }
`;
